<template>
  <div class="bg-base" @click="closeDialog">
    <template v-if="type == '1'">
      <!-- 现金问卷 -->
      <div class="bg-card">
        <div class="bg-close">
          <img src="../assets/img/close-area.png" alt="" @click="closeDialog">
        </div>
        <div class="bg-top">
          <div class="bg-top-left">
            <img src="../assets/img/cash.png" alt="">
            <span>奖励金转入微信零钱</span>
          </div>
          <template v-if="dialog.status == '0'">
            <div class="status greenColor">已申请</div>
          </template>
          <template v-else-if="dialog.status == '1'">
            <div class="status redColor">已提现</div>
          </template>
          <template v-else>
            <div class="status grayColor">已失效</div>
          </template>
        </div>
        <div class="bg-cell">
          <div class="bg-cell-title">成交金额</div>
          <div class="bg-cell-money">{{ dialog.prMoney }}元</div>
        </div>
        <div class="bg-cell-cl">
          <div class="bg-cell-title">交易详情</div>
          <div class="bg-cell-text">[{{ dialog.cashPrId }}]{{ dialog.prTitle }}</div>
        </div>
        <div class="bg-cell-cl">
          <div class="bg-cell-title">账户详情</div>
          <div class="bg-cell-text">备注：已申请奖励金转入微信零钱</div>
          <div class="bg-cell-text">创建时间：{{ dialog.addTime }}</div>
          <div v-if="dialog.isShowExtrabonus" class="bg-cell-text">附加奖励：+{{ dialog.extrabonus }}元（连环项目奖励）</div>
        </div>
        <div class="bg-cell-cl" v-if="dialog.status == '1'">
          <div class="bg-cell-title">成功提现</div>
          <div class="bg-cell-text">奖励金已转入微信零钱</div>
          <div class="bg-cell-text">交易号：{{ dialog.orderNo }}</div>
        </div>

        <div class="finish-content" v-if="dialog.isShowBtn">
            <div class="finish-btn errcolor" v-if="dialog.isHadTixian">加速成功</div>
            <div class="finish-btn" v-if="!dialog.isHadTixian" @click="tixian">加速提现</div>
        </div>

        <div class="zh-container" v-if="dialog.status == 0">
          <div class="zh-space-left"></div>
          <div class="zh-notice-content">
            <div class="zh-notice">通常我们会在问卷关闭后的7天内完成提现。</div>
            <div class="zh-notice">通过加速提现，您可以在1个工作日完成提现。</div>
            <div class="zh-notice">未来我们还将提供即时提现服务。</div>
          </div>
          <div class="zh-space-right"></div>
        </div>
      </div>
    </template>
    <template v-else-if="type == '2'">
      <!-- 即付问卷 -->
      <div class="bg-card">
        <div class="bg-close">
          <img src="../assets/img/close-area.png" alt="" @click="closeDialog">
        </div>
        <div class="bg-top">
          <div class="bg-top-left">
            <img src="../assets/img/cash.png" alt="">
            <span>奖励金转入微信零钱</span>
          </div>
          <template v-if="dialog.status == '2'">
            <div class="status greenColor">已申请</div>
          </template>
          <template v-else-if="dialog.status == '1'">
            <div class="status redColor">已提现</div>
          </template>
          <template v-else>
            <div class="status grayColor">已失败</div>
          </template>
        </div>
        <div class="bg-cell">
          <div class="bg-cell-title">成交金额</div>
          <div class="bg-cell-money">{{ dialog.money }}元</div>
        </div>
        <div class="bg-cell-cl">
          <div class="bg-cell-title">交易详情</div>
          <div class="bg-cell-text">[{{ dialog.ssiprid }}]即付问卷完成</div>
        </div>
        <div class="bg-cell-cl">
          <div class="bg-cell-title">账户详情</div>
          <template v-if="dialog.status == '2'">
            <div class="bg-cell-text">备注：已申请奖励金转入微信零钱</div>
          </template>
          <template v-else-if="dialog.status == '1'">
            <div class="bg-cell-text">备注：已申请奖励金转入微信零钱</div>
          </template>
          <template v-else>
            <div class="bg-cell-text">备注：当日提现名额超限，请隔日申请</div>
          </template>
          <div class="bg-cell-text">创建时间：{{ dialog.addtime }}</div>
        </div>
        <div class="bg-cell-cl" v-if="dialog.status == '1'">
          <div class="bg-cell-title">成功提现</div>
          <div class="bg-cell-text">奖励金已转入微信零钱</div>
          <div class="bg-cell-text">交易号：{{ dialog.orderno }}</div>
        </div>

        <template v-if="dialog.status == '0'">
          <div class="finish-content">
            <div class="finish-btn" @click="onTapTixianAgain">再次提现</div>
          </div>
        </template>
        <template v-else-if="dialog.status == '2'">
          <div class="finish-content">
            <div class="finish-btn errcolor">提现申请已提交</div>
          </div>
        </template>
        <template v-if="dialog.status != '1'">
          <div class="zh-container">
            <div class="zh-space-left"></div>
            <div class="zh-notice-content">
              <div class="zh-notice">提现申请提交后，会在一个工作日内进行处理。</div>
            </div>
            <div class="zh-space-right"></div>
          </div>
        </template>
      </div>
    </template>
    <template v-else>
      <!-- 点子问卷 -->
      <div class="bg-card">
        <div class="bg-close">
          <img src="../assets/img/close-area.png" alt="" @click="closeDialog">
        </div>
        <div class="bg-top">
          <div class="bg-top-left">
            <img src="../assets/img/zhangdan@2x.png" alt="">
            <span>{{ dialog.surveyName }}</span>
          </div>
          <div class="status greenColor">交易成功</div>
        </div>
        <div class="bg-cell">
          <div class="bg-cell-title">成交点子</div>
          <div class="bg-cell-money">{{ dialog.point }}</div>
        </div>
        <div class="bg-cell-cl">
          <div class="bg-cell-title">交易详情</div>
          <div class="bg-cell-text">{{ dialog.surveyId }}</div>
        </div>
        <div class="bg-cell-cl">
          <div class="bg-cell-title">账户详情</div>
          <div class="bg-cell-text">备注：{{ dialog.surveyName }}</div>
          <div class="bg-cell-text">创建时间：{{ dialog.addTime }}</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'DialogCard',
  props: ['dialog', 'type'],  // type = 1 现金，type = 2 即付， type = 3 点子
  mounted() {
     if (this.type == '1') {
       // 现金
       if (this.dialog.extrabonus) {
         this.dialog.prMoney = this.dialog.prMoney + '+' + this.dialog.extrabonus;
       }else {
         this.dialog.prMoney = '+' + this.dialog.prMoney;
       }

       // 附加奖励
       if ((this.dialog.status == 0 || this.dialog.status == 1) && this.dialog.extrabonus) {
         this.dialog.isShowExtrabonus = true;
       }else {
         this.dialog.isShowExtrabonus = false;
       }

       // 显示不同按钮
        if (this.dialog.status == 0) {
          // 已申请，显示按钮及不同颜色
          this.dialog.isShowBtn = true
          if (this.dialog.extrabonus) {
            this.dialog.isHadTixian = true
          }else {
            this.dialog.isHadTixian = false
          }
        }else  {
          // 其他状态，不显示按钮
          this.dialog.isShowBtn = false
        }

     }else if (this.type == '2') {
       // 即付

     }else {
       // 点子
     }
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog')
    },

    // 现金提现
    tixian() {
      this.$emit('tixian');
    },

    // 即付再次体现
    onTapTixianAgain() {
      this.$emit('tixianAgain');
    }
  }
}
</script>

<style>
.bg-base {
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.3);
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-close {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  height: 20px;
  margin-top: 10px;
}

.bg-close img {
  width: 14px;
  height: 14px;
  margin-right: 20px;
}

.bg-card {
  background: #EBEBEB;
  border-radius: 4px;
  /* width: 400px; */
  height: 600px;
  -webkit-box-shadow: 0 3px 15px 0 rgba(0,0,0,.3);
  box-shadow: 0 3px 15px 0 rgba(0,0,0,.3);
  display: flex;
  flex-direction: column;
  -webkit-animation: fadeInDown .3s;
  animation: fadeInDown .3s;
}

@keyframes fadeInDown {
    0% {
        -webkit-transform: translate3d(0, -20%, 0);
        -webkit-transform: translate3d(0, -20%, 0);
        transform: translate3d(0, -20%, 0);
        transform: translate3d(0, -20%, 0);
        opacity: 0;
    }
    100% {
        -webkit-transform: none;
        transform: none;
        opacity: 1;
    }
}

.bg-top {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
}

.bg-top-left {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.bg-top-left img {
  width: 30px;
  height: 30px;
}

.bg-top-left span {
  font-size: 14px;
  color: #333;
  margin-left: 10px;
}

.status {
  color: #65ae71;
  font-size: 14px;
}

.bg-cell {
  background: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px 10px;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;
}

.bg-cell-cl {
  background: white;
  display: flex;
  flex-direction: column;
  padding: 10px 10px;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;
}

.bg-cell-title {
  font-size: 13px;
  color: #999;
}

.bg-cell-text {
  font-size: 14px;
  color: #333;
  margin-top: 10px;
}

.bg-cell-money {
  font-size: 20px;
  color: #333;
}

.greenColor {
  color: #65AE71;
}

.redColor {
  color: #F08177;
}

.grayColor {
  color: #999;
}

.finish-content {
	display: flex;
	align-items: center;
	justify-content: center;
}

.finish-btn {
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
	margin-top: 20px;
  margin-left: 10px;
  margin-right: 10px;
	background: #65ae71;
	border-radius: 4px;
	color: #fff;
	font-size: 15px;
	text-align: center;
	line-height: 45px;
  width: 380px;
}

.finish-err-btn {
  border-radius: 4px;
	color: #fff;
	font-size: 15px;
	text-align: center;
	line-height: 45px;
	background: #A6A6A6;
    margin-left: 10px;
  margin-right: 10px;
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
	margin-top: 20px;
}

.zh-container {
	display: flex;
	flex-direction: row;
	margin-top: 20px;
}

.zh-notice-content {
	flex-shrink: 0;
}

.zh-notice {
	font-size: 14px;
	color: #666;
	line-height: 20px;
}

.zh-space-left {
	flex-grow: 1;
}

.zh-space-right {
	flex-grow: 3;
}
.errcolor {
  background: #A6A6A6;
}

/* 手机 */
@media screen and (max-width: 768px) {
	.bg-card {
    width: 90%;
  }
}

/* Pad */
@media screen and (min-width: 768px) and (max-width: 1023px) {
  .bg-card {
    width: 400px;
  }
}

/* 中屏幕电脑 */
@media screen and (min-width: 1024px) and (max-width: 1199px) {
  .bg-card {
    width: 400px;
  }
}

/* 大屏幕电脑 */
@media screen and (min-width: 1200px) {
  .bg-card {
    width: 400px;
  }
}
</style>
